import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_address_book_hdr_RowInterface {
    guid:                       fromDatatype.GuidDataFieldInterface;
    name:                       fromDatatype.VarcharDatatypeInterface;
    code:                       fromDatatype.VarcharDatatypeInterface;
    type:                       fromDatatype.VarcharDatatypeInterface;
    created_date:               fromDatatype.TimestampTzDatatypeInterface;
    updated_date:               fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:    fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:    fromDatatype.GuidDataFieldInterface;
    status:                     fromDatatype.VarcharDatatypeInterface;
    revision:                   fromDatatype.GuidDataFieldInterface;
    vrsn:                       fromDatatype.VarcharDatatypeInterface;
    owner_login_subject_guid:   fromDatatype.GuidDataFieldInterface;
    last_sync_date:             fromDatatype.TimestampTzDatatypeInterface;

}

export class  bl_crm_address_book_hdr_RowClass implements bl_crm_address_book_hdr_RowInterface {

    guid:                       fromDatatype.GuidDataFieldInterface;
    name:                       fromDatatype.VarcharDatatypeInterface;
    code:                       fromDatatype.VarcharDatatypeInterface;
    type:                       fromDatatype.VarcharDatatypeInterface;
    created_date:               fromDatatype.TimestampTzDatatypeInterface;
    updated_date:               fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid:    fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid:    fromDatatype.GuidDataFieldInterface;
    status:                     fromDatatype.VarcharDatatypeInterface;
    revision:                   fromDatatype.GuidDataFieldInterface;
    vrsn:                       fromDatatype.VarcharDatatypeInterface;
    owner_login_subject_guid:   fromDatatype.GuidDataFieldInterface;
    last_sync_date:             fromDatatype.TimestampTzDatatypeInterface;
  
  }
  